<div class="apply-one-grid apply-one-style">
  <div class="site-width">
    <div class="container-fluid">
      <div class="py-2">
        @if (suggestedContractViewModel && canDisplayAlert) {
        <ng-container [ngTemplateOutlet]="content"></ng-container>
        } @else {
        <ng-container [ngTemplateOutlet]="spinner"></ng-container>
        }
      </div>
    </div>
  </div>
</div>
<!-- CONTENT -->
<ng-template #content>
  @if (feedback === null) {
  <ng-container [ngTemplateOutlet]="ui"></ng-container>
  } @else {
  <ng-container [ngTemplateOutlet]="error" [ngTemplateOutletContext]="{$implicit: feedback}"></ng-container>
  }
</ng-template>
<!-- UI -->
<ng-template #ui>
  <div class="d-none d-md-block">
    <a
      (click)="backToContractSelector(removeContractTranslations?.backRouteTitle);false"
      [href]="contractSelectorLink | link | async"
      class="o-link-arrow back mb-2"
      >{{"dashboard.removeContract.backRouteTitle" | translate}}</a
    >
    <h1 class="d-none d-md-block" data-e2e="title">{{"dashboard.removeContract.title" | translate}}</h1>
  </div>
  <h2 class="no-signature pt-2 pt-md-0 mb-0" data-e2e="item-title">{{suggestedContractViewModel?.offerName}}</h2>
  <div class="lead text-gray3" data-e2e="item-offer">{{suggestedContractViewModel?.detail | phone}}</div>
  @if (suggestedContractViewModel?.delegation) {
  <div class="lead font-weight-bold contract-delegation">
    {{"dashboard.removeContract.delegation" | translate}}{{suggestedContractViewModel?.delegation}}
  </div>
  } @if (suggestedContractViewModel?.member?.displayName) {
  <div class="lead font-weight-bold text-orange1">{{suggestedContractViewModel?.member?.displayName}}</div>
  } @if (suggestedContractViewModel?.state !== 'LOGGED') {
  <div class="row">
    <div class="col-12 col-md-10 col-xl-8">
      <div class="lead font-weight-bold contract-detail-title" data-e2e="contract-detail-title">
        {{"dashboard.removeContract.detailTitle" | translate}}
      </div>
      <div class="lead text-gray3" data-e2e="contract-detail">{{detail}}</div>
    </div>
  </div>
  }
  <div class="row mt-2">
    <div class="col-12 col-md-10 col-xl-8">
      @if (!asAnExclusionAlert) {
      <p class="alert alert-info" role="alert" data-e2e="alert-info">
        <span class="alert-icon icon-info"></span>
        <span>{{info}}</span>
      </p>
      } @if (asAnExclusionAlert) {
      <p class="alert alert-warning" role="alert" data-e2e="alert-warning">
        <span class="alert-icon icon-Warning-important"></span>
        <span>{{info}}</span>
      </p>
      }
    </div>
  </div>
  <div class="row">
    <div class="col-12 col-md-10 col-xl-8">
      <div class="d-inline-flex flex-row justify-content-end w-100 mb-4">
        <a
          (click)="backToContractSelector(removeContractTranslations?.cancel);false"
          [href]="contractSelectorLink | link | async"
          class="o-link-arrow back"
        >
          {{"dashboard.removeContract.cancel" | translate}}</a
        >
        @if (!(suggestedContractViewModel?.state === 'LOGGED' && suggestedContractViewModel.role === 'Titulaire')) {
        <a [href]="currentUrl" (click)="validateSuppression();false" class="btn btn-primary ml-3">
          {{"dashboard.removeContract.submit" | translate}}</a
        >
        }
      </div>
    </div>
  </div>
</ng-template>
<!-- FEEDBACK -->
<ng-template #error let-feedback>
  <div class="mt-1 mb-2 my-md-3">
    <ecm-mat-feedback
      [style]="feedback.style"
      [title]="feedback.title"
      [text]="feedback.detail"
      [confirmationLabel]="feedback.confirmationLabel"
      (materialFeedbackConfirm)="backToHome()"
    >
    </ecm-mat-feedback>
  </div>
</ng-template>
<!-- SPINNER -->
<ng-template #spinner>
  <div class="py-5">
    <ecm-mat-spinner [centered]="true"></ecm-mat-spinner>
  </div>
</ng-template>
